/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-preloader[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-direction:column}.custom-preloader[_ngcontent-%COMP%]   .big-spinner[_ngcontent-%COMP%]{width:80px;height:80px;top:unset;margin:0}"];
export { styles as styles };
